import React from 'react';
import { X } from 'lucide-react';
export function PainSection() {
  return <section className="py-14 md:py-20 bg-negro" data-id="element-325">
      <div className="container" data-id="element-326">
        <div className="grid grid-cols-2 gap-10 items-center max-md:grid-cols-1 max-md:gap-8" data-id="element-327">
          <div data-id="element-328">
            <div className="section-label" data-id="element-329">¿Te identificas?</div>
            <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco" data-id="element-330">
              El poder invisible que
              <br data-id="element-331" />
              mueve a las personas
            </h2>
            <ul className="mt-7 list-none" data-id="element-332">
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-333">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-334">
                  <X className="w-3.5 h-3.5" data-id="element-335" />
                </span>
                <span data-id="element-336">
                  Sientes que otros logran lo que quieren con facilidad mientras
                  tú luchas por ser escuchado.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-337">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-338">
                  <X className="w-3.5 h-3.5" data-id="element-339" />
                </span>
                <span data-id="element-340">
                  Has sido manipulado sin darte cuenta — en el trabajo, en
                  relaciones, en decisiones de compra.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-341">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-342">
                  <X className="w-3.5 h-3.5" data-id="element-343" />
                </span>
                <span data-id="element-344">
                  Quieres influir con más impacto pero no sabes qué mecanismos
                  psicológicos activar.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 text-[.95rem] text-crema-oscuro" data-id="element-345">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-346">
                  <X className="w-3.5 h-3.5" data-id="element-347" />
                </span>
                <span data-id="element-348">
                  Crees que aprender estas técnicas es "poco ético" — cuando
                  ignorarlas es lo que te pone en desventaja.
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-349">
            <div className="bg-negro-suave border border-[rgba(201,151,43,.15)] rounded-lg overflow-hidden" data-id="element-350">
              <img src="https://cdn.magicpatterns.com/uploads/sFmjoufnEFGj9WMbDLdtYW/Gemini_Generated_Image_m65vkxm65vkxm65v.png" alt="Psicología oscura — El poder invisible que mueve a las personas" className="w-full block" data-id="element-351" />
              <div className="py-[18px] px-[22px] font-cormorant italic text-[1rem] text-dorado-palido text-center" data-id="element-352">
                "El conocimiento de la influencia es neutral. El poder lo define
                quien lo posee."
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}